import React from "react";
import { BrowserRouter } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import { blueGrey } from "@material-ui/core/colors";
// import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import App from "App";

const colorPrimary = {
  light: "#FFF",
  main: "#666666",
  dark: "#0D5876",
  contrastText: "#FFF",
  brandPrimary: "#127DA9",
};

const colorSecondary = {
  light: "#EFEFEF",
  main: "#00AFF0",
  dark: "#0D5876",
  contrastText: "#FFF",
};

const theme = createMuiTheme({
  typography: {
    fontFamily: ["proxima-soft", "sans-serif"].join(","),
    htmlFontSize: 14,
  },
  palette: {
    primary: colorPrimary,
    secondary: colorSecondary,
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        a: {
          color: colorPrimary.dark,
          textDecoration: "none",
          fontWeight: 700,
        },
        html: {
          height: "100%",
          fontSize: 14,
        },
        body: {
          height: "100%",
          margin: 0,
          overflowX: "hidden",
        },
        "#root": {
          height: "100%",
        },
        ul: {
          marginTop: 0,
          paddingLeft: 20,
        },
        ol: {
          "& > li::marker": {
            fontWeight: "bold",
          },
        },
        li: {
          fontSize: "1rem",
        },
      },
    },
    MuiLink: {
      root: {
        color: blueGrey[900],
      },
    },
    MuiInput: {
      root: {
        color: colorPrimary.main,
      },
      underline: {
        "&:before": {
          borderBottom: `1px solid ${colorPrimary.main}`,
          opacity: ".3",
        },
        "&:after": {
          borderBottom: `2px solid ${colorSecondary.main}`,
        },
      },
    },
    MuiFormLabel: {
      root: {
        "&.Mui-focused": {
          color: colorSecondary.main,
        },
        fontSize: "1.25rem",
      },
    },
    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: colorPrimary.light,
        },
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: colorPrimary.dark,
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: colorPrimary.dark,
        "&:hover": {
          backgroundColor: colorPrimary.dark,
        },
      },
    },
    MuiButton: {
      // Name of the rule
      contained: {
        // Some CSS
        backgroundColor: colorPrimary.dark,
        color: colorSecondary.contrastText,
        padding: "6px 32px",
        textTransform: "none",
        fontWeight: 500,
        fontSize: "1rem",
        borderRadius: 0,
        "&:hover": {
          backgroundColor: "#127DA9",
        },
      },
    },
    MuiTabs: {
      indicator: {
        height: 4,
      },
    },
    MuiTab: {
      root: {
        marginRight: 30,
        padding: 0,
        minWidth: 0,
        "@media (min-width: 600px)": {
          padding: 0,
          minWidth: 0,
        },
      },
      wrapper: {
        color: colorPrimary.dark,
        fontWeight: "bold",
      },
    },
    MuiTypography: {
      colorTextSecondary: {
        color: colorSecondary.contrastText,
      },
      h1: {
        fontSize: "3rem",
        fontFamily: "proxima-soft, serif",
        fontWeight: 400,
        color: colorPrimary.dark,
      },
      h2: {
        fontSize: "1rem",
        lineHeight: "1.25rem",
        fontFamily: "proxima-soft, sans-serif",
        fontWeight: 300,
        color: colorPrimary.main,
        letterSpacing: 0.84,
      },
      h3: {
        fontSize: "1rem",
        lineHeight: "1.25rem",
        fontFamily: "proxima-soft, sans-serif",
        fontWeight: 300,
        color: colorPrimary.main,
        letterSpacing: 0.84,
      },
      h5: {
        fontWeight: 700,
      },
      h6: {
        fontWeight: 700,
      },
      body1: {
        fontSize: "1rem",
      },
      body2: {
        fontSize: "1rem",
        marginBottom: 16,
      },
    },
  },
});

const Root = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
);

export default Root;
